import React from 'react';
import { Icon } from './Icon.js';
export const IconCaretLeftFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M13.094,2.442c-.559-.309-1.242-.288-1.781,.055L3.389,7.522c-.509,.323-.812,.875-.812,1.478s.304,1.155,.812,1.478l7.924,5.025c.286,.181,.611,.271,.937,.271,.29,0,.581-.072,.844-.217,.559-.308,.906-.895,.906-1.533V3.976c0-.638-.347-1.226-.906-1.533Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconCaretLeftFill18.js.map